"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleMobileMenu = toggleMobileMenu;
var menuEl = document.querySelector('.page-header__menu');
var hamburgerEl = document.querySelector('.icon--hamburger');
var expanded = false;
function toggleMobileMenu(el) {
  var enterKeyCode = 13;
  var spaceKeyCode = 32;
  el.addEventListener('click', function () {
    event.preventDefault();
    menuToggling();
  });
  el.addEventListener('keyup', function (event) {
    if (event.keyCode == enterKeyCode || event.keyCode == spaceKeyCode) {
      if (!expanded) {
        showMenu();
      } else {
        hideMenu();
      }
    }
  });
}
function hideMenu() {
  menuEl.classList.remove('page-header__menu--toggle');
}
function showMenu() {
  menuEl.classList.add('page-header__menu--toggle');
}
function menuToggling() {
  menuEl.classList.toggle('page-header__menu--toggle');
  menuEl.setAttribute('aria-expanded', 'true');
  if (expanded) {
    hamburgerEl.classList.add('icon--open');
    hamburgerEl.classList.remove('icon--close');
    expanded = false;
  } else {
    hamburgerEl.classList.remove('icon--open');
    hamburgerEl.classList.add('icon--close');
    expanded = true;
  }
}